"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getClassNames = exports.getCurrentCountry = exports.getCountryData = exports.translateCountryName = void 0;
const constants_1 = require("../utils/constants");
const constants_2 = require("./constants");
const translateCountryName = (country) => {
    return constants_2.translationsNameCountry[country] || country;
};
exports.translateCountryName = translateCountryName;
const getCountryData = () => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const response = yield fetch('https://restfulcountries.com/api/v1/countries', {
            headers: {
                Authorization: 'Bearer OUcfIQZWyFzyBQxHNz7jjSj8eLnwBcnFUeudfepa',
            },
        });
        const { data } = yield response.json();
        return data.map((country) => {
            return {
                value: `+${country.phone_code}`,
                label: `${(0, exports.translateCountryName)(country.name)}`,
                flag: country.href.flag,
                flagCDN: `https://flagcdn.com/${country.iso2}.png`.toLowerCase(),
                isShowImage: true,
            };
        });
    }
    catch (error) {
        return [];
    }
});
exports.getCountryData = getCountryData;
const getCurrentCountry = () => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        if (timezone === '' || !timezone) {
            return null;
        }
        const country = constants_1.timezones[timezone].c[0];
        const countryFiltered = constants_1.countries[country];
        const response = yield fetch(`https://restfulcountries.com/api/v1/countries/${countryFiltered}`, {
            headers: {
                Authorization: 'Bearer OUcfIQZWyFzyBQxHNz7jjSj8eLnwBcnFUeudfepa',
            },
        });
        const { data } = yield response.json();
        return {
            phoneCode: `+${data.phone_code}`,
            label: data.name,
            selectedFlag: data.href.flag,
        };
    }
    catch (error) {
        return null;
    }
});
exports.getCurrentCountry = getCurrentCountry;
const getClassNames = (sizeInput, state) => {
    const inputClassnames = `d-flex align-items-center c-phoneinput -${state}`;
    if (sizeInput === 'medium') {
        return `${inputClassnames} medium-input-phone`;
    }
    if (sizeInput === 'small') {
        return `${inputClassnames} small-input-phone`;
    }
    if (sizeInput === 'large') {
        return `${inputClassnames} large-input-phone`;
    }
    return inputClassnames;
};
exports.getClassNames = getClassNames;
//# sourceMappingURL=utils.js.map